import React, {useEffect, useState} from "react";
import './Premium.scss';

import Header from "../../components/Header";
import Button from "react-bootstrap/Button";
import Footer from "../../components/Footer";
import Alert from "react-bootstrap/Alert";

let img_top = require("../../assets/Blog.jpg");

let video = require("../../assets/premium/video.mp4");
let img1 = require("../../assets/premium/1.jpg");
let img2 = require("../../assets/premium/2.jpg");
let img3 = require("../../assets/premium/3.jpg");
let img4 = require("../../assets/premium/4.jpg");
let img5 = require("../../assets/premium/5.jpg");
let img6 = require("../../assets/premium/6.jpg");
let mockup2 = require("../../assets/premium/mockup2.png");

function Premium() {
    useEffect(() => {
        document.title = "Geoticket - Premium";
    }, []);
    const [list, setList] = useState([]);

    useEffect(() => {
        fetch(global.route.blogList, {
            method: "post",
            credentials: 'include',
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(response => {
                        setList(response.list);
                    });
                }
            });
    }, []);


    return (
        <div style={{backgroundColor: "#fafafa"}} className={"premium-info"}>
            <Header/>
            <div>
                <div>
                    <div style={{width: "100%"}}>
                        <div style={{
                            display: "flex",
                            flex: 1,
                            flexDirection: "column",
                            backgroundImage: `url(${img1})`,
                            alignItems: "center",
                            padding: 24,
                            paddingTop: 120,
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            minHeight: 350,
                            backgroundSize: "cover",
                            gap: 6
                        }}>
                            <div className={"container"} style={{
                                display: "flex", flexDirection: "column", alignItems: "center",
                            }}>
                                <div style={{flex: 1, alignContent: "flex-start"}}>
                                    <h1 style={{
                                        color: "#fafafa",
                                        fontWeight: 400,
                                        textAlign: "center"
                                    }}>Scopri dove stanno nascendo<br/> <b
                                        style={{fontWeight: "bold"}}>in tempo reale</b></h1>
                                    <h3 style={{
                                        color: "#fafafa",
                                        fontWeight: 500,
                                        textAlign: "center"
                                    }}>grazie alla tabella crescite più affidabile di sempre</h3>
                                </div>
                                <div style={{flex: 1, alignContent: "center"}}>
                                    <Button className={"btn-orange"} style={{fontSize: 24}} href={"/download-app"}>
                                        Scarica GRATIS l’applicazione
                                    </Button>
                                </div>
                                <div style={{flex: 1, alignContent: "flex-end"}}>
                                    <span style={{color: "#fafafa", justifyContent: "flex-end"}}>L’applicazione è disponibile sia su Android che su iOS</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"container"}>
                    <div className="page-container premium-row"
                         style={{display: "flex", flexDirection: "row", paddingTop: 12, paddingBottom: 12}}>
                        <div style={{
                            display: "flex",
                            flex: 1,
                            flexDirection: "column",
                            gap: 12,
                            paddingTop: 24,
                            paddingBottom: 24,
                            alignSelf: "flex-start"
                        }}>
                            <h2>Non rimanere mai senza funghi"</h2>
                            <p style={{fontSize: 20}}>Guarda le previsioni, programma la tua escursione, e fai il tuo
                                permesso con un click</p>
                            <p>La migliore esperienza a funghi di sempre ti aspetta. Salta la coda, arriva per primo al
                                posto giusto al momento giusto, trova le migliori fungaie grazie alla tabella crescite
                                più affidabile di sempre. Scopri come funziona!</p>
                        </div>
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <video style={{height: "100%", maxHeight: 350}} controls className={"video-premium"}
                                   autoPlay muted>
                                <source src={video} type="video/mp4"/>
                            </video>
                        </div>
                    </div>
                </div>
                <div className={"container d-flex justify-content-center align-items-center mb-4"}>
                    <Button className={"btn-orange"} style={{fontSize: 24}} href={"/download-app"}>
                        STOP tabelle crescita inaffidabili
                    </Button>
                </div>
                <div>
                    <div style={{width: "100%"}}>
                        <div style={{
                            display: "flex",
                            flex: 1,
                            flexDirection: "column",
                            backgroundImage: `url(${img2})`,
                            alignItems: "center",
                            padding: 24,
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            minHeight: 350,
                            backgroundSize: "cover",
                            gap: 6
                        }}>
                            <div className={"container"} style={{
                                display: "flex", flexDirection: "column", alignItems: "center",
                            }}>
                                <div style={{flex: 1, alignContent: "flex-start"}}>
                                    <h1
                                        style={{
                                            color: "#fafafa",
                                            fontWeight: 400,
                                            textAlign: "center"
                                        }}>La prima mappa sviluppata da micologi</h1>
                                    <h3
                                        style={{
                                            color: "#fafafa",
                                            fontWeight: 500,
                                            textAlign: "center"
                                        }}>Anni di esperienza e studi in collaborazione alla tecnologia più avanzata del
                                        momento hanno creato</h3>
                                </div>
                                <div style={{flex: 1, alignContent: "center"}}>
                                    <p style={{
                                        fontWeight: "bold",
                                        fontSize: 35,
                                        color: "#fafafa",
                                        textAlign: "center"
                                    }}>UNA TABELLA INTELLIGENTE</p>
                                </div>
                                <div style={{flex: 1, alignContent: "flex-end"}}>
                                    <h3 style={{
                                        color: "#fafafa",
                                        justifyContent: "flex-end",
                                        fontWeight: 500,
                                        textAlign: "center"
                                    }}>che incrocia milioni di dati ambientali, climatici e territoriali per darti
                                        previsioni di crescita affidabili e SEMPRE in tempo reale</h3>
                                </div>
                                <Button className={"btn-orange"} style={{fontSize: 24}} href={"/download-app"}>
                                    Scarica GRATIS l’applicazione
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"container"}>
                    <div className="page-container"
                         style={{display: "flex", flexDirection: "column", gap: 12, paddingTop: 12, paddingBottom: 12}}>
                        <p style={{fontSize: 22}}>Chi l’ha già provata non ne può più fare a meno</p>

                        <div className={"premium-row"}
                             style={{display: "flex", flexDirection: "row", marginTop: 16, marginBottom: 16}}>
                            <div style={{
                                padding: 16,
                                borderRadius: 16,
                                borderWidth: 2,
                                borderStyle: "solid",
                                marginLeft: 12,
                                marginRight: 24,
                                paddingTop: 24,
                                paddingBottom: 24,
                                borderColor: "rgb(81, 178, 112)",
                                backgroundColor: "#fdfaf4",
                                display: "flex",
                                marginTop: 6
                            }}>
                                <p>Finalmente so dove andare a cercare funghi senza tornare a mani vuote. La tabella AI
                                    è fantastica!</p>
                                <img src={img4} alt={"feedback1"} style={{
                                    height: 64,
                                    width: 64,
                                    borderRadius: 50,
                                    borderWidth: 2,
                                    borderColor: "rgb(81, 178, 112)",
                                    borderStyle: "solid",
                                    marginRight: -48
                                }}/>
                            </div>
                            <div style={{
                                padding: 16,
                                borderRadius: 16,
                                borderWidth: 2,
                                borderStyle: "solid",
                                marginLeft: 12,
                                marginRight: 24,
                                paddingTop: 24,
                                paddingBottom: 24,
                                borderColor: "rgb(81, 178, 112)",
                                backgroundColor: "#fdfaf4",
                                display: "flex",
                                marginTop: 6

                            }}>
                                <p>Ho trovato funghi che non avevo mai visto prima. La tecnologia mi ha davvero
                                    aiutata.</p>
                                <img src={img5} alt={"feedback1"} style={{
                                    height: 64,
                                    width: 64,
                                    borderRadius: 50,
                                    borderWidth: 2,
                                    borderColor: "rgb(81, 178, 112)",
                                    borderStyle: "solid",
                                    marginRight: -48
                                }}/>
                            </div>
                            <div style={{
                                padding: 16,
                                borderRadius: 16,
                                borderWidth: 2,
                                borderStyle: "solid",
                                marginLeft: 12,
                                marginRight: 24,
                                paddingTop: 24,
                                paddingBottom: 24,
                                borderColor: "rgb(81, 178, 112)",
                                backgroundColor: "#fdfaf4",
                                display: "flex",
                                marginTop: 6

                            }}>
                                <p>Ho scoperto nuove zone proprio vicino a casa che non pensavo fossero così ricche di
                                    funghi, fantastica tabella!</p>
                                <img src={img6} alt={"feedback1"} style={{
                                    height: 64,
                                    width: 64,
                                    borderRadius: 50,
                                    borderWidth: 2,
                                    borderColor: "rgb(81, 178, 112)",
                                    borderStyle: "solid",
                                    marginRight: -48
                                }}/>
                            </div>
                        </div>

                        <p style={{fontSize: 22}}>Fai parte della nostra community di <b
                            style={{fontWeight: "bold"}}>più di 150mila appassionati</b> tra Facebook, Instagram e
                            TikTok
                        </p>
                        <div className={"container d-flex justify-content-center align-items-center mb-4"}>
                            <Button className={"btn-orange"} style={{fontSize: 24}} href={"/premium-purchase"}>
                                Mi iscrivo a Geoticket+
                            </Button>
                        </div>
                    </div>

                </div>
                <div>
                    <div style={{width: "100%"}}>
                        <div style={{
                            display: "flex",
                            flex: 1,
                            flexDirection: "column",
                            backgroundImage: `url(${img3})`,
                            alignItems: "center",
                            padding: 24,
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            minHeight: 350,
                            backgroundSize: "cover",
                            gap: 6
                        }}>
                            <div className={"container"} style={{
                                display: "flex", flexDirection: "column", alignItems: "center", flex:1,
                            }}>
                                <div style={{flex: 1, alignContent: "flex-start"}}>
                                    <h1
                                        style={{
                                            color: "#fafafa",
                                            fontWeight: 400,
                                            textAlign: "center"
                                        }}>Scopri dove in un click</h1>
                                    <h2
                                        style={{
                                            color: "#fafafa",
                                            fontWeight: 500,
                                            textAlign: "center"
                                        }}>E non tornare MAI PIU’ a casa a mani vuote</h2>
                                </div>
                                <div style={{flex: 1, alignContent: "flex-end"}}>
                                    <h3 style={{
                                        color: "#fafafa",
                                        justifyContent: "flex-end",
                                        fontWeight: 500,
                                        textAlign: "center"
                                    }}>Scarica GRATIS l’applicazione</h3>
                                    <h3 style={{
                                        color: "#fafafa",
                                        justifyContent: "flex-end",
                                        fontWeight: 500,
                                        textAlign: "center"
                                    }}>L’applicazione è disponibile sia su Android che su iOS</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="page-container premium-row"
                         style={{display: "flex", flexDirection: "row", paddingTop: 12, paddingBottom: 12}}>
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <img src={mockup2} alt={"Screen"} style={{height: 350, width: "auto"}}/>
                        </div>
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 12,
                            paddingTop: 24,
                            paddingBottom: 24,
                            alignSelf: "flex-start"
                        }}>
                            <p style={{fontSize: 24, fontWeight: "bold"}}>Tutti i vantaggi di Geoticket+</p>
                            <p style={{fontSize: 20}}>Non solo tabella di previsione crescite funghi</p>
                            <p>Aderisci a Geoticket+ e avrai:</p>
                            <ul>
                                <li style={{
                                    listStyle: "circle",
                                    marginLeft: 18
                                }}>Mappe dettagliate delle aree dei ticket
                                </li>
                                <li style={{
                                    listStyle: "circle",
                                    marginLeft: 18
                                }}>Kit digitale per funghi con tracker GPS, percorsi personalizzati e registro di
                                    raccolta
                                </li>
                                <li style={{
                                    listStyle: "circle",
                                    marginLeft: 18
                                }}>Accedi a Geoticket+ Funghi League: una classifica per la raccolta dei funghi
                                </li>
                                <li style={{
                                    listStyle: "circle",
                                    marginLeft: 18
                                }}>Notifiche e avvisi su aggiornamenti dell'area, previsioni meteo, crescita dei funghi
                                    e altro ancora
                                </li>
                            </ul>
                            <div className=" d-flex justify-content-center align-items-center mb-4">
                                <Button className={"btn-orange"} style={{fontSize: 24}} href={"/premium-purchase"}>
                                    Mi iscrivo a Geoticket+
                                </Button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <Footer/>
        </div>
    );
}

export default Premium;